import React from "react";
import classNames from "classnames";
import { IconSizes } from "../Icons/PropTypes/IconSizes";
import { CancelIcon } from "../Icons";
import NotificationBarIcon from "./NotificationBarIcon";
export var NotificationBarType;
(function (NotificationBarType) {
    NotificationBarType["Info"] = "info";
    NotificationBarType["Alert"] = "alert";
    NotificationBarType["Warning"] = "warning";
    NotificationBarType["Success"] = "success";
    /* eslint-disable @typescript-eslint/naming-convention */
    /** @deprecated Use NotificationBarType.Warning or NotificationBarType.Alert instead */
    NotificationBarType["Danger"] = "danger";
    /** @deprecated Use NotificationBarType.Info instead */
    NotificationBarType["info"] = "info";
    /** @deprecated Use NotificationBarType.Danger instead */
    NotificationBarType["danger"] = "danger";
    /** @deprecated Use NotificationBarType.Warning instead */
    NotificationBarType["warning"] = "warning";
    /* eslint-enable @typescript-eslint/naming-convention */
})(NotificationBarType || (NotificationBarType = {}));
const NotificationBar = ({ type = NotificationBarType.Info, text, open, icon, title, content, hideIcon, className, handleClose, }) => {
    if (!open)
        return null;
    return (React.createElement("section", { className: classNames(`gerudo-notification-bar`, `${type}`, className), title: "Notification" },
        !hideIcon && (icon ? icon : React.createElement(NotificationBarIcon, { type: type })),
        React.createElement("div", { className: "gerudo-notification-bar-content" },
            React.createElement("h1", null, title),
            React.createElement("div", null, content || text)),
        handleClose && (React.createElement("button", { onClick: handleClose },
            React.createElement(CancelIcon, { size: IconSizes.Xsmall, title: "Close notification bar" })))));
};
export default NotificationBar;
export { NotificationBar };
//# sourceMappingURL=index.js.map